import React from 'react';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

export const EmptyState = () => {
  const { t } = useTranslation();

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={t('Nessuna pagina statica trovata')}
      style={{ padding: '40px 0' }}
    />
  );
}; 